import {Pipe, PipeTransform} from '@angular/core';
import {Platform} from '../classes/platform';
import {CheckpointStatusOrbsEnum} from '../classes/checkpoint-status-orbs.enum';

@Pipe({
    name: 'PlatformLevelStatusPipe'
})
export class PlatformLevelStatusPipe implements PipeTransform {

    transform(level: string, platform: Platform): string {
        const levelMapping = {
            production: {
                count: platform.checkpoint_production_count,
                errorCount: platform.checkpoint_production_error_count,
                warningCount: platform.checkpoint_production_warning_count,
                alertCount: platform.checkpoint_production_postpone_count,
                lastInstance: platform.checkpoint_production_last_instance ? platform.checkpoint_production_last_instance[0]?.updated_at : null
            },
            health: {
                count: platform.checkpoint_health_count,
                errorCount: platform.checkpoint_health_error_count,
                warningCount: platform.checkpoint_health_warning_count,
                alertCount: platform.checkpoint_health_postpone_count,
                lastInstance: platform.checkpoint_health_last_instance ? platform.checkpoint_health_last_instance[0]?.updated_at : null
            },
            check: {
                count: platform.checkpoint_check_count,
                errorCount: platform.checkpoint_check_error_count,
                warningCount: platform.checkpoint_check_warning_count,
                alertCount: platform.checkpoint_check_postpone_count,
                lastInstance: platform.checkpoint_check_last_instance ? platform.checkpoint_check_last_instance[0]?.updated_at : null
            },
            acceptance: {
                count: platform.checkpoint_acceptance_count,
                errorCount: platform.checkpoint_acceptance_error_count,
                warningCount: platform.checkpoint_acceptance_warning_count,
                alertCount: platform.checkpoint_acceptance_postpone_count,
                lastInstance: platform.checkpoint_acceptance_last_instance ? platform.checkpoint_acceptance_last_instance[0]?.updated_at : null,
            }
        };

        const checkpointData = levelMapping[level];


        if (!checkpointData || checkpointData.count === 0) {
            return CheckpointStatusOrbsEnum.inactive;
        }

        const formatedLastInstance = checkpointData.lastInstance ? new Date(checkpointData.lastInstance) : null;
        const timeAhead = new Date();
        timeAhead.setDate(timeAhead.getDate() - 1);
        if (checkpointData.errorCount !== 0 || checkpointData.lastInstance && formatedLastInstance < timeAhead) {
            return CheckpointStatusOrbsEnum.error;
        }

        if (platform.closest_ssl_expiry_date || platform.closest_acceptance_ssl_expiry_date) {
            const sslState = this.sslValidUntil(level, platform);
            if (sslState !== '') {
                return sslState;
            }
        }

        if (checkpointData.warningCount !== 0) {
            return CheckpointStatusOrbsEnum.warning;
        }

        if (checkpointData.alertCount !== 0) {
            return CheckpointStatusOrbsEnum.alert;
        }

        return CheckpointStatusOrbsEnum.success;
    }

    private sslValidUntil(level: string, platform: Platform) {
        const formattedExpiryDate = new Date(platform.closest_ssl_expiry_date);
        const fiveDaysToGo = new Date();
        const oneWeekToGo = new Date();
        const tenDaysToGo = new Date();
        const twoWeeksToGo = new Date();

        fiveDaysToGo.setDate(fiveDaysToGo.getDate() + 5);
        oneWeekToGo.setDate(oneWeekToGo.getDate() + 7);
        tenDaysToGo.setDate(tenDaysToGo.getDate() + 10);
        twoWeeksToGo.setDate(twoWeeksToGo.getDate() + 14);

        if (level === 'production' && formattedExpiryDate <= fiveDaysToGo) {
            return CheckpointStatusOrbsEnum.error;
        } else if (level === 'health' && formattedExpiryDate <= oneWeekToGo) {
            return CheckpointStatusOrbsEnum.error;
        } else if (level === 'health' && formattedExpiryDate <= tenDaysToGo) {
            return CheckpointStatusOrbsEnum.warning;
        } else if (level === 'check' && formattedExpiryDate <= twoWeeksToGo) {
            return CheckpointStatusOrbsEnum.warning;
        }

        if (level === 'acceptance') {
            const formattedAcceptanceExpiryDate = new Date(platform.closest_acceptance_ssl_expiry_date);
            if (formattedAcceptanceExpiryDate <= oneWeekToGo) {
                return CheckpointStatusOrbsEnum.error;
            } else if (formattedAcceptanceExpiryDate <= twoWeeksToGo) {
                return CheckpointStatusOrbsEnum.warning;
            }
        }
        return '';
    }
}
